import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  getMyQueueRecheckList,
  updateConfig,
} from "../../../store/slices/Packings/packingsSlice";
// import { startTimerRecheck } from "../api"; // Timer feature disabled
import { toast } from "react-toastify";

const usePacking = () => {
  const packingState = useSelector((state) => state.packings);
  const states = packingState?.myQueueRecheckList;
  const [showDetail, setShowDetail] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pendingPage, setPendingPage] = useState(1);
  const [activeCard, setActiveCard] = useState({ id: "", key: "" });
  const [detailId, setDetailId] = useState("");
  const dispatch = useDispatch();
  const slug = sessionStorage?.getItem("slug");
  const [clickedCardId, setClickedCardId] = useState(null);

  useEffect(() => {
    dispatch(
      updateConfig((state) => {
        state.searchRecheck = "";
      }),
    );
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(
      getMyQueueRecheckList({
        page: pendingPage,
        process_slug: slug,
        search: packingState?.searchRecheck,
      }),
    );
    // eslint-disable-next-line
  }, [pendingPage, slug]);

  // Timer feature disabled
  // const startTimerPacking = (item) => {
  //   setClickedCardId(item?._id);
  //   if (!item?._id || clickedCardId === item._id) {
  //     return;
  //   }
  //   let body = {
  //     receipt_id: item,
  //     process_slug: slug,
  //     order_type: 2,
  //   };
  //   startTimerRecheck(body).then((response) => {
  //     if (response?.data?.status_code === 200) {
  //       toast.success("Timer Started");
  //     } else {
  //       toast.error("Can't Start Timer");
  //     }
  //   });
  // };

  const handleChange = (id) => {
    setActiveCard({ id: id, key: "Pending" });
    // startTimerPacking(id); // Timer feature disabled
    setDetailId(id);
    setShowDetail(true);
    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.selectedId = id;
        state.table.currentPage = 1;
        state.clear = true;
      }),
    );
    const timmerId = setTimeout(() => {
      dispatch(updateConfig((state) => (state.clear = false)));
      clearTimeout(timmerId);
    }, 100);
  };

  const handleSearch = () => {
    const value = packingState?.searchRecheck;
    dispatch(
      updateConfig((state) => {
        state.myQueueRecheckList.Pending = [];
        state.searchRecheck = value;
      }),
    );
    dispatch(
      getMyQueueRecheckList({
        search: value,
        process_slug: slug,
      }),
    );
  };

  const handleInputSearch = (e) => {
    dispatch(updateConfig((state) => (state.searchRecheck = e.target.value)));
  };

  const handleLoadMore = (mouseHover) => {
    if (
      mouseHover === "Pending" &&
      packingState?.Pending?.length !== packingState?.total?.Pending
    ) {
      setPendingPage(pendingPage + 1);
      // dispatch(
      //   updateConfig((state) => {
      //     state.search = packingState?.search;
      //   })
      // );
    }
  };

  return {
    packingState,
    states,
    showDetail,
    activeCard,
    isLoading,
    totalLength: {
      Pending: packingState.total.Pending,
    },
    apiStatus: {
      Pending: packingState.RecheckQueueStatus,
    },
    itemId: packingState.selectedPacking?.[0]?.[0],
    detailId,
    handleSearch,
    handleChange,
    handleInputSearch,
    setIsLoading,
    handleLoadMore,
  };
};

export default usePacking;
